import { Text, View } from '@react-pdf/renderer';
import ReportFlex from './ReportFlex';
import styles from './styles';
import { useTranslation } from 'react-i18next';

type Props = {
  header: string;
  children: React.ReactNode | React.ReactNode[];
  noWrap?: boolean;
};

function ReportAccordion({ header, children, noWrap }: Props) {
  const { t } = useTranslation();

  return (
    <ReportFlex column noWrap={noWrap}>
      <View style={styles.accordionHeader}>
        <Text>{t(header)}</Text>
      </View>
      <View style={styles.accordionContent}>{children}</View>
    </ReportFlex>
  );
}

export default ReportAccordion;
